
import Button from "../../components/UI/Button/Button";
import Input from "../../components/UI/Input/Input";
import Modal from "../../components/UI/Modal/Modal";
import { Collapse } from "@material-ui/core";
import ContentForm from "../../components/UI/ContentForm/ContentForm";
import { useEffect, useRef, useState } from "react";
import { updateObject } from "../../shared/utility";
import ShowBoxes from "./ShowBoxes";
import fetchData from "../../shared/fetchData";

const Generation2Lockers = () => {
    const [kioskInfo, setKioskInfo] = useState({
        kioskId: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'شناسه لاکر'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
    });
    const [boxes, setBoxes] = useState([]);
    const [showBoxes, setShowBoxes] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const [rerender, setRerender] = useState(false);
    const [lockerSerial, setLockerSerial] = useState('');
    const childRef = useRef();

    useEffect(() => {
        const bxs = [];
        for (let i = 1; i < 26; i++) {
            bxs.push({
                id: i,
                serial: i
            })
            setBoxes(bxs);
        }
    }, [])
    useEffect(() => {
        if (showResult) {
            setTimeout(() => {
                setShowResult(false);
            }, 5000);
        }
    }, [showResult])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(kioskInfo, {
            [controlName]: updateObject(kioskInfo[controlName], {
                value: event.target.value,
                valid: true,
            })
        });
        setKioskInfo(updatedControls)
    }

    const boxClicked = (event, lockerSerial) => {
        setLockerSerial(lockerSerial);
        childRef.current.openModal();
    }

    const openLockerDoor = (event) => {
        var raw = JSON.stringify({
            "kioskId": kioskInfo.kioskId.value,
            "lockerSerial": lockerSerial,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/lockers/openLockerDoor';
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == '0') {
                    setShowResult(true);
                    childRef.current.closeModal();
                }
            })
            .catch(error => console.log())
    }

    const modalContent = <>
        <div className="row justify-content-center" >
            آیا از باز کردن درب لاکر مطمئن هستید؟
        </div>
        <div className="row justify-content-center mt-4" >
            <div className='col-6 text-center'>
                <Button btnType="Success" clicked={openLockerDoor}>بله</Button>
            </div>
            <div className='col-6 text-center'>
                <Button btnType="General" clicked={() => childRef.current.closeModal()}>خیر</Button>
            </div>
        </div>
    </>

    const formElementsArray = [];
    for (let key in kioskInfo) {
        formElementsArray.push({
            id: key,
            config: kioskInfo[key]
        })
    }
    let form = formElementsArray.map(formElement => {
        let col = '4 mt-2'
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col={col}
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        )
    })
    return (
        <div className='row justify-content-center w-100 ml-0 mr-0'>
            <ContentForm headetText='باز کردن درب لاکر نسل ۲'>
                <Collapse in={showResult} style={{ width: '100%' }} >
                    <div className='row justify-content-center w-100 ml-0 mr-0 mt-4'>
                        باکس {lockerSerial} در لاکر {kioskInfo.kioskId.value} باز شد!
                    </div>
                </Collapse>
                <div className='row justify-content-center w-100 ml-0 mr-0 mt-5'>
                    {form}
                </div>
                <div className='row justify-content-center w-100 ml-0 mr-0 mt-4'>
                    <div className='col-6 text-center'>
                        <Button btnType="General" clicked={() => {
                            let valid = true;
                            const ki = kioskInfo
                            for (let key in ki) {
                                if (ki[key].value == '') {
                                    ki[key].valid = false
                                    valid = false
                                }
                            }
                            if (!valid) {
                                setKioskInfo(ki);
                                setRerender(!rerender);
                            } else {
                                setShowResult(false);
                                setShowBoxes(true);
                            }
                        }}>نمایش باکس‌ها</Button>
                    </div>
                </div>
                <Collapse in={showBoxes} style={{ width: '100%' }} >
                    <ShowBoxes boxes={boxes} boxClicked={boxClicked} />
                </Collapse>
            </ContentForm>
            <Modal
                content={modalContent}
                ref={childRef}
                closePermission="true"
                closeModal={(event) => console.log()}
            />
        </div>

    )
}

export default Generation2Lockers;